export default {
    setTagsinfo(state, payload){
        if (Object.keys(state.tags).length <= 500){
            state.tags[payload._id] = payload
        }
    },
};
